import Button from '@/components/Buttons/Button';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import RightArrow from '@/images/arrows/RightArrow.svg';
import { useCampaignCreateContext } from '@/pages/campaign/CreatePage/context';
import { CAMPAIGN_TABS } from '@/pages/campaign/CreatePage/types';
import { useAnalytics } from '@/services/analytics';
import { AppRoutes } from '@/utils/types';
import styled from '@emotion/styled';
import { observer } from 'mobx-react-lite';
import { useFormContext } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import { useClearForm } from '../../hooks';

const ButtonsContainer = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const StyledButton = styled(Button)`
    min-width: 180px;
`;

const StyledInfoButton = styled(StyledButton)`
    border: 1px solid ${({ theme }) => theme.colors.black[300]};
`;

const tabOrder = [CAMPAIGN_TABS.AVATAR, CAMPAIGN_TABS.VOICE_SCRIPT, CAMPAIGN_TABS.VIDEO_PAGE];

export const HeaderButtons = observer(() => {
    const mixpanel = useAnalytics();
    const {
        formState: { isSubmitting, isDirty },
        getValues,
    } = useFormContext();
    const navigate = useNavigate();
    const { currentTab, setCurrentTab } = useCampaignCreateContext();
    const clearForm = useClearForm();
    const showCreateButton = currentTab === CAMPAIGN_TABS.VIDEO_PAGE;

    const handlePrevClick = () => {
        mixpanel?.track('campaigns-editor', {
            page: currentTab,
            action: 'back',
            event: 'click',
            campaign: getValues(),
        });
        const currentIndex = tabOrder.indexOf(currentTab);
        if (currentIndex > 0) {
            setCurrentTab(tabOrder[currentIndex - 1]);
        } else {
            clearForm();
            navigate(AppRoutes.Campaigns);
        }
    };

    const handleNextClick = () => {
        mixpanel?.track('campaigns-editor', {
            page: currentTab,
            action: 'next',
            event: 'click',
            campaign: getValues(),
        });

        const currentIndex = tabOrder.indexOf(currentTab);
        if (currentIndex < tabOrder.length - 1) {
            setCurrentTab(tabOrder[currentIndex + 1]);
        }
    };

    return (
        <ButtonsContainer>
            <StyledInfoButton color="info" onClick={handlePrevClick} id="campaign-back-btn">
                Back
            </StyledInfoButton>

            {!showCreateButton && (
                <StyledButton
                    color="secondary"
                    onClick={handleNextClick}
                    endIcon={<MaskedIcon src={RightArrow} size="20px" id="campaign-next-btn" />}>
                    Next
                </StyledButton>
            )}

            {showCreateButton && (
                <StyledButton
                    color="secondary"
                    type="submit"
                    disabled={!isDirty}
                    isLoading={isSubmitting}
                    id="submit-create-btn"
                    onClick={() => {
                        mixpanel?.track('campaigns-create', {
                            event: 'generate',
                            campaign: getValues(),
                        });
                    }}>
                    Create Campaign
                </StyledButton>
            )}
        </ButtonsContainer>
    );
});
